import { useClient } from '@composables/use-clients';
import {
  PostRequestArgsType,
  PutRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type PutCurrentTenantUserPayloadType = {
  title: string;
  description: string;
};

export type UpdateCurrentTenantUserArgsType = (
  PutRequestArgsType<PutCurrentTenantUserPayloadType>
);

export type DeleteCurrentTenantUserSerializerType = {
  domain: string;
};

export const apiFetchCurrentTenantUser = async ({
  domain = useTenantStore().domain,
  errorConfig = {},
  callbacks = {},
} = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.currentTenantUser({ domain }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiUpdateCurrentTenantUser = async ({
  domain = useTenantStore().domain,
  payload,
  errorConfig = {},
  callbacks = {},
}: UpdateCurrentTenantUserArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.put({
      url: urls.v1.currentTenantUser({ domain }),
      payload,
    });
    return res;
  };
  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteCurrentTenantUser = async ({
  domain = useTenantStore().domain,
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<DeleteCurrentTenantUserSerializerType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.currentTenantUserDelete({ domain }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
